export const alphaSliderCSSVars = {
    sliderDirectionVar: `--fui-AlphaSlider--direction`,
    sliderProgressVar: `--fui-AlphaSlider--progress`,
    thumbColorVar: `--fui-AlphaSlider__thumb--color`,
    railColorVar: `--fui-AlphaSlider__rail--color`
};
